import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9.026 3.254a2 2 0 0 1 2.022.044h.002l17.979 10.996a1.987 1.987 0 0 1 0 3.412L11.05 28.701l-.002.001A2.001 2.001 0 0 1 8 27.001V4.999a2 2 0 0 1 1.026-1.745M28.513 15.15l-.516.843.006-.004-.004.005-.002.006q0 .003.002.006l.005.005zm-.527.85L10 5v21.998l.003-.002z"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconPlay = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconPlay);
export default Memo;
